import { render, staticRenderFns } from "./RcLabel.vue?vue&type=template&id=1cf66720"
import script from "./RcLabel.vue?vue&type=script&lang=js"
export * from "./RcLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports